import React, { useContext, useEffect, useState, useRef } from 'react';
import { FlatList, Image, StyleSheet, Text, View } from 'react-native';
import QRCodeStyling from "qr-code-styling";

import colors from "../config/colors";
import { EventContext } from "../context/Event.context";
import Page from '../components/Page';
import Template from '../services/Template';
import { GenerateURL } from '../services/QrCode.service';
import QrCode from '../components/QrCode';

interface IQrCodeInfo {
  url: string,
  club: string
}

export default function Print() {
  const eventContext = useContext(EventContext);
  const [uri, setUri] = useState("");
  const [qrCodes, setQrCodes] = useState<IQrCodeInfo[]>();
  const ref = useRef(null);

  const conferenceId = eventContext.event?.conference;

  // const qrCode = new QRCodeStyling(t);
  // let rawList: Blob[] = [];

  useEffect(() => {
    console.log("Clubs: ", eventContext.clubs);
    setQrCodes(eventContext.clubs.map((club) => {
      club.conference = conferenceId;
      let url = GenerateURL(club.id!, club.name!, club.conference!);
      let q: IQrCodeInfo = {
        url: url,
        club: club.name!
      };
      return q;
    }))
  }, [eventContext.clubs]);

  // async function loadCodes() {
  //   let b = await qrCode.getRawData("png");
  //   if (b) {
  //     rawList.push(b);
  //   }
  //   if (ref && ref.current) {
  //     qrCode.append(ref.current);
  //   }
  // }

  // async function getUri() {
  //   return "data:image/png;base64," + await rawList[0].text;
  // }


  return (
    <Page title="QrCode Page" backgroundColor={colors.white} >
      <Text>Qtd: {qrCodes?.length}</Text>
      <FlatList
        showsVerticalScrollIndicator={true}
        data={qrCodes}
        contentContainerStyle={styles.grid}
        numColumns={3}
        keyExtractor={(item, index) => index.toString()}
        renderItem={({ item }) => {
          return (
            <View style={styles.item}>
              <QrCode data={item.url} text={item.club} size={500} margin={0} />
              <Text style={styles.txt}>Clube: {item.club}</Text>
            </View>
          )
        }} />
    </Page>
  )
}

const styles = StyleSheet.create({
  grid: {
    //backgroundColor: colors.greyD,
    marginTop: 16,
    marginBottom: 32,
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-start',
  },
  item: {
    maxWidth: 520,
    paddingTop: 10,
    paddingHorizontal: 5,
    paddingBottom: 40,
    margin: 1,
    borderColor: colors.black,
    borderWidth: 1,
    backgroundColor: colors.white,
    color: colors.black,
    resizeMode: 'contain',
  },
  txt: {
    color: colors.black,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 30,
  },
  url: {
  },
});